export default __webpack_public_path__ + "static/media/The Race II.190bf414.jpg";